import { Injectable } from '@angular/core';
import { NgUserService } from './ng-user.service';
import { User } from './user';

@Injectable({
  providedIn: 'root'
})
export class FlagService {
  legantoFeatures: { [key: string]: any };

  constructor(private userService: NgUserService) {}

  _user = (): User => this.userService.user;

  features = (): { [key: string]: any } => this._user().legantoFeatures || {};
  customerSetting = (): { [key: string]: any } => this._user().customerSetting;

  isZoteroSupported(): boolean {
    let zoteroSettings = this._user().preferences?.citationMngmt?.zotero;
    return zoteroSettings?.apiKey && zoteroSettings?.userId;
  }

  isRefworksSupported(): boolean {
    let refSettings = this._user().preferences?.citationMngmt?.refworks;
    return (this.customerSetting().newRefworksSupport || this.customerSetting().refworksSupport) && refSettings?.username && refSettings?.password;
  }
  /**userTokenExists ||*/
  isMendeleySupported = (): boolean =>
    this._user().preferences.citationMngmt && this._user().preferences.citationMngmt.mendeley && this._user().preferences.citationMngmt.mendeley.accessToken;

  isUploadFileAllowed = (): boolean => (this._user().ltiSystemType ? this._user().cmsEntryFileSize : this._user().fileSize) && this.features().display_file_option == 'true';

  isEnablePayPerUse = (): boolean => this._user().enablePayPerUse;

  isDeeplinkRequest = (): boolean => this._user().deeplinkRequest;

  isDisplayAnnottaionToggel = (): boolean => this.features().allow_citation_public_annotation == 'true';

  isLegantoViewerActive = (): boolean => this.features().pdf_use_leganto_viewer == 'true';

  isLegantoViewerInActive = (): boolean => this.features().pdf_use_leganto_viewer == 'false';

  isLegantoViewerReadOnly = (): boolean => this.features().pdf_use_leganto_viewer == 'readonly';

  showMarkAsBroken = (): boolean => 'all' == this.features().mark_as_broken || 'links' == this.features().mark_as_broken;

  showMarkAsBrokenAll = (): boolean => 'all' == this.features().mark_as_broken;

  showMarkAsBrokenUploadFile = (): boolean => this._user().markAsBrokenFileVisible;

  isInstructorCanManageCitationAvailability = (): boolean => this.features().instructor_manage_citation_availability_link == 'true';

  allowAssignmentsManagment = (): boolean => false;

  defaultSectionName = (): string => this._user().default_section_name;

  get = (flag: string) => this._user()[flag];
}
